module.exports = __webpack_public_path__ + "static/media/logo-cdstpni.8f4cf3a0.png";